export const title = '¡Hola!';
export const subTitle = '';
export const body = 'Bienvenido/a a Volbi business, '
+ 'la aplicación que hace que tus clientes vuelvan más';
export const stampCard = 'Marcar una tarjeta';
